import {Component} from '@angular/core';
import {ConfirmDialog} from 'primeng/confirmdialog';
import {Button} from 'primeng/button';
import {TranslocoPipe} from '@jsverse/transloco';

@Component({
  selector: 'app-confirmation-dialog',
  imports: [ConfirmDialog, Button, TranslocoPipe],
  templateUrl: './confirmation-dialog.component.html',
})
export class ConfirmationDialogComponent {}
